import { render, staticRenderFns } from "./portDataGoodsInfo.vue?vue&type=template&id=f22ced9a&scoped=true&"
import script from "./portDataGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./portDataGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./portDataGoodsInfo.vue?vue&type=style&index=0&id=f22ced9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22ced9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f22ced9a')) {
      api.createRecord('f22ced9a', component.options)
    } else {
      api.reload('f22ced9a', component.options)
    }
    module.hot.accept("./portDataGoodsInfo.vue?vue&type=template&id=f22ced9a&scoped=true&", function () {
      api.rerender('f22ced9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/tabs/portDataGoodsInfo.vue"
export default component.exports